import { useState } from 'react';
import { api } from '../api';
import { money, useLoad } from '../lib';

// Orders buyers submitted for sign-off. Approve releases to the vendor (→ pending); reject cancels.
// Both are the same order-status mutation under the hood (BFF gates admin/ops).
export function ApprovalsPanel() {
  const [busy, setBusy] = useState<number | null>(null);
  const [msg, setMsg] = useState<string | null>(null);
  const { data, err, reload } = useLoad(() => api.commerceApprovals());

  async function act(id: number, approve: boolean) {
    setBusy(id);
    setMsg(null);
    try {
      await api.commerceSetOrderStatus(id, approve ? 'pending' : 'canceled');
      setMsg(`#${id} ${approve ? 'approved' : 'rejected'}`);
      reload();
    } catch (e) {
      setMsg(`⚠ ${(e as Error).message}`);
    } finally {
      setBusy(null);
    }
  }

  return (
    <div className="stack">
      <h1>Approvals</h1>
      <p className="sub">Orders buyers submitted for approval — approve to release to the vendor, or reject</p>
      {err && <p className="msg bad">⚠ {err}</p>}
      {msg && <p className={`msg ${msg.startsWith('⚠') ? 'bad' : 'good'}`}>{msg}</p>}
      <section className="card">
        <table>
          <thead><tr><th>PO #</th><th>Camp</th><th>Vendor</th><th>Category</th><th className="num">Items</th><th className="num">Total</th><th>Delivery</th><th></th></tr></thead>
          <tbody>
            {(data ?? []).map((r) => (
              <tr key={r.id}>
                <td className="mono">{r.increment_id}</td>
                <td>{r.camp ?? '—'}</td>
                <td>{r.vendor ?? '—'}</td>
                <td>{r.attribute_set_type ? <span className="pill type">{r.attribute_set_type}</span> : '—'}</td>
                <td className="num">{r.items}</td>
                <td className="num">{money(r.grand_total)}</td>
                <td className="muted">{r.delivery_date ?? '—'}</td>
                <td className="actions">
                  <button className="btn-sm" disabled={busy === r.id} onClick={() => act(r.id, true)}>Approve</button>
                  <button className="btn-sm ghost" disabled={busy === r.id} onClick={() => act(r.id, false)}>Reject</button>
                </td>
              </tr>
            ))}
            {data && data.length === 0 && <tr><td colSpan={8} className="loading">No orders awaiting approval.</td></tr>}
          </tbody>
        </table>
        {!data && !err && <p className="loading">Loading…</p>}
      </section>
    </div>
  );
}
